import { render, staticRenderFns } from "./NextAppointmentsPatient.vue?vue&type=template&id=9f1aee40&scoped=true&"
import script from "./NextAppointmentsPatient.vue?vue&type=script&lang=js&"
export * from "./NextAppointmentsPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1aee40",
  null
  
)

export default component.exports